module.exports = __webpack_public_path__ + "static/media/remove.6b237c10.svg";